module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAIVBMVEWvFTXOESa+pML////+/v8iMJYMHIwmOI6yyqs6dyg6dygr+lKdAAAAC3RSTlP+////////////1Ap/yP8AAAA8SURBVHjaY2EgGbAIkq6FYVTLqJZRLSNSiyAdtDDSyS9Ko6XlqJaRmiv3DFa/hI7mylEto1pGtQyi0hIA0y8CuIAoIpkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/gm.png
// module id = x4sv
// module chunks = 0